/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import { DeleteOutlined, EditFilled, QuestionCircleOutlined } from '@ant-design/icons';
import {
  Button,
  Collapse, Row, Table, Tooltip, Typography
} from 'antd';
import React, { memo } from 'react';

import Image from 'common/components/Image';
import { Item, Section } from 'common/services/packages/types';

interface TablePreviewProps {
  sections: Section[];
  numberCol: number | null;
  onDelete: (idx: number) => void;
  onEdit?: (section: Section) => void;
}

const TablePreview: React.FC<TablePreviewProps> = memo(({
  sections, numberCol, onDelete, onEdit
}) => (
  <Collapse accordion>
    {sections.map((section, sectionIndex) => (
      <Collapse.Panel
        header={(
          <div className="p-packageCompare_header">
            <Row>
              {section.icon && <div className="p-packageCompare_iconPreview"><Image ratio="1x1" src={section.icon} alt={section.name} /></div>}
              <Typography.Title level={5} style={{ marginLeft: '10px' }}>{section.name}</Typography.Title>
            </Row>
            <div>
              <Button onClick={() => onEdit?.(section)}>
                <EditFilled />
              </Button>

              <Button onClick={() => onDelete(sectionIndex)}>
                <DeleteOutlined />
              </Button>
            </div>
          </div>
        )}
        key={section.name + sectionIndex}
      >
        <Table
          dataSource={section.items}
          columns={[
            {
              dataIndex: 'name',
              key: 'name',
              render: (text, record) => (record.description ? (
                <Tooltip title={record.description}>
                  <span style={{ cursor: 'pointer' }}>
                    {text}
                    {' '}
                    <QuestionCircleOutlined />
                  </span>
                </Tooltip>
              ) : (
                text
              )),
            },
            ...Array.from({ length: numberCol || 0 }, (_, i) => ({
              title: ' ',
              key: `detail_${i}`,
              render: (__: any, record: Item) => (section.type === 'boolean'
                ? record.details[i] === true
                  ? '✅'
                  : '❌'
                : String(record.details[i] || '')),
            })),
          ]}
          pagination={false}
          rowKey={(record) => record.name}
          bordered
        />
      </Collapse.Panel>
    ))}
  </Collapse>
));

export default TablePreview;
